import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-pages-auth-callback',
  templateUrl: 'auth-callback-view.component.html',
  standalone: false,
})
export class AuthCallbackViewComponent implements OnInit {
  constructor() {}

  public ngOnInit() {}
}
